import handleNotOkResponse from "@jnctn/error-handling/handleNotOkResponse";
import { FetchUnauthorizedRequest } from "@jnctn/error-handling/Errors";

export type MemberRole =
  | "Member"
  | "Trainer / Assessor"
  | "Organisation Admin"
  | "Admin"
  | "Coreadmin"
  | "Registration"
  | "Verifier";

export type Checksum = {
  checksum: string;
  clientName: string;
  firstName: string;
  image?: string;
  lastName: string;
  memberRole: MemberRole;
  tenantLogoUrl: string;
  tenantName: string;
  tenantId: string;
  isActive: boolean;
  profileComplete: boolean;
};

export default async function fetchChecksums(
  accessToken: string | undefined
): Promise<Array<Checksum>> {
  let res: Response | undefined;
  if (accessToken === undefined) {
    return [];
  }

  try {
    res = await fetch(
      `${process.env.REACT_APP_QUERY_API_URL}/app/index/checksums/`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        credentials: "include",
      }
    );
  } catch (error) {
    throw new FetchUnauthorizedRequest(fetchChecksums, "Unauthorized");
  }

  if (!res.ok) {
    handleNotOkResponse(res, fetchChecksums);
  }

  return res.json();
}
